<template lang="pug">
  #Ingreso
    Header

    div.ingreso-page
      v-container(fluid)
        v-row(justify='center' align='start')
          v-col(cols='12' sm='8' md='5' lg='4')

            //- ── Login ────────────────────────────────────────────────────
            div.ing-card
              div.ing-card-header
                v-icon.ing-header-icon mdi-account-circle-outline
                h2.ing-title Iniciar sesión
                p.ing-subtitle Bienvenido de vuelta

              div.ing-form
                div.ing-field
                  label.ing-label Correo electrónico
                  v-text-field(
                    outlined
                    v-model='form.email'
                    placeholder='tu@correo.com'
                    color='#FF6200'
                    hide-details='auto'
                    dense
                    prepend-inner-icon='mdi-email-outline'
                  )
                div.ing-field
                  label.ing-label Contraseña
                  v-text-field(
                    outlined
                    v-model='form.password'
                    type='password'
                    placeholder='••••••••'
                    color='#FF6200'
                    hide-details='auto'
                    dense
                    prepend-inner-icon='mdi-lock-outline'
                  )

                a.ing-forgot(href='/recuperar')
                  v-icon(size='13') mdi-help-circle-outline
                  | ¿Olvidaste tu contraseña?

                v-btn(@click='login()' class='ing-btn-login' block).elevation-0
                  v-icon(left size='16') mdi-login
                  | Iniciar sesión

    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import Swal from 'sweetalert2/dist/sweetalert2.min.js'
import { mapState, mapActions } from 'vuex'
import { serverImg } from '@/services/environment'
export default {
  name: 'Ingreso',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      pantalla: screen.width,
      ruta: serverImg,
      beneficios: [
        'Realiza pedidos fácilmente',
        'Consulta precios y stock',
        'Historial de compras',
        'Atención personalizada'
      ]
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    login () {
      if (this.form.email && this.form.password) {
        Api.post('clientesWeb/login', this.form)
          .then(response => {
            if (response.data.status !== 'denied') {
              this.$store.dispatch('login', response.data)
              this.$cookies.set('token', response.data.token, '5D', '')
              window.location.href = '/'
            } else {
              Swal.fire(
                'Oops...',
                response.data.message,
                'error'
              )
            }
          })
          .catch(error => {
            Swal.fire(
              'Oops...',
              'Error de conexión, intente nuevamente o contacte con el administrador.',
              'error'
            )
            console.log(error)
          })
      } else {
        this.showAlert()
      }
    },
    showAlert () {
      Swal.fire({
        title: 'Error encontrado.',
        text: 'Estimado cliente, debe ingresar usuario y contraseña para ingresar.',
        icon: 'error'
      })
    },
    initialize () {
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/ingreso.scss";
</style>
